import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const token = this.getTokenFromStorage();
    const tenantId = localStorage.getItem('selectedTenantId');

    const isApiUrl = request.url.startsWith(environment.apiUrl);

    if (isApiUrl) {

      const headers: any = {};

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      if (tenantId) {
        headers['X-Tenant-ID'] = tenantId;
      }

      request = request.clone({
        setHeaders: headers
      });
    }

    return next.handle(request);
  }

  private getTokenFromStorage(): string | null {
    const storedUser = localStorage.getItem('currentUser');

    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        return userData.token || null;
      } catch {
        return null;
      }
    }

    return null;
  }
}